import Vue from 'vue';
import store, { getters, mutations } from '@/store';
import { notifications } from 'pdk/services';

export default function GroupAdminOnlyGuard(to, from, next) {
    if (!Vue.$auth.authenticated) {
        Vue.$auth.login({ redirectUri: to.fullPath });
    }
    else if (!store.getters[getters.USER_GROUPS_IS_ADMIN]) {
        if (typeof store.state.groupRoles !== 'undefined') {
            notifications.open({
                content: 'You do not have the required permissions for this page.'
            });
        }
        else {
            let called = false;
            var unsubscribe;
            unsubscribe = store.subscribe((mutation) => {
                if (mutation.type === mutations.USER_GROUP_ROLES_SET) {
                    if (store.getters[getters.USER_GROUPS_IS_ADMIN]) {
                        next();
                    }
                    else {
                        notifications.open({
                            content: 'You do not have the required permissions for this page.'
                        });
                    }
                    called = true;
                    if (typeof unsubscribe === 'function') unsubscribe();
                }
            });

            setTimeout(() => {
                if (!called) {
                    notifications.open({
                        content: 'You do not have the required permissions for this page.'
                    });
                }
                if (typeof unsubscribe === 'function') unsubscribe();
            }, 3000);
        }
	}
	else {
		next();	
	}
};
